var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner"},[_c('p',[_vm._v(_vm._s(_vm.$t('settings.readOnlyAccess')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }